module.exports = __webpack_public_path__ + "static/media/chevrolet.7946e95b.svg";